(function () {
  'use strict';

  function initProductPage(root) {
    if (!root || root.dataset.ruqyProductInit === 'true') return;
    root.dataset.ruqyProductInit = 'true';

    initGallery(root);
    initVariantPicker(root);
    initAccordion(root);
    initWishlist(root);
  }

  function initWishlist(root) {
    var button = root.querySelector('[data-ruqy-wishlist]');
    var handle = root.getAttribute('data-product-handle');
    if (!button || !handle) return;

    var storageKey = 'ruqy-wishlist';
    var defaultLabel = button.textContent.trim() || 'Save to Wishlist';

    function readWishlist() {
      try {
        var saved = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(saved) ? saved : [];
      } catch (error) {
        return [];
      }
    }

    function updateButton(isSaved) {
      button.classList.toggle('active', isSaved);
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      button.textContent = isSaved ? 'Saved to Likes' : defaultLabel;
    }

    updateButton(readWishlist().includes(handle));
    button.addEventListener('click', function () {
      var handles = readWishlist();
      var index = handles.indexOf(handle);
      if (index >= 0) {
        handles.splice(index, 1);
      } else {
        handles.push(handle);
      }
      window.localStorage.setItem(storageKey, JSON.stringify(handles));
      updateButton(handles.includes(handle));
      document.dispatchEvent(new CustomEvent('ruqy:wishlist-change', { detail: { handles: handles } }));
    });
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-ruqy-thumb]');
    var slots = root.querySelectorAll('[data-ruqy-slot]');
    var previous = root.querySelector('[data-ruqy-gallery-previous]');
    var next = root.querySelector('[data-ruqy-gallery-next]');
    if (!slots.length) return;

    var activeIndex = 0;

    function showImage(index) {
      activeIndex = (index + slots.length) % slots.length;

      slots.forEach(function (slot, slotIndex) {
        slot.classList.toggle('active', slotIndex === activeIndex);
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        var isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    }

    thumbs.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        showImage(index);
      });
    });

    if (previous) {
      previous.addEventListener('click', function () {
        showImage(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showImage(activeIndex + 1);
      });
    }
  }

  function initVariantPicker(root) {
    var form = root.querySelector('[data-ruqy-product-form]');
    var variantInput = form && form.querySelector('[name="id"]');
    var variantDataEl = root.querySelector('[data-ruqy-variants]');
    var lengthBtns = root.querySelectorAll('[data-ruqy-length]');
    var priceEl = root.querySelector('[data-ruqy-price]');
    var addBtn = root.querySelector('[data-ruqy-add-btn]');

    if (!form || !variantInput || !variantDataEl) return;

    var variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      return;
    }

    var optionNames = (variantDataEl.getAttribute('data-ruqy-option-names') || '')
      .split('|')
      .filter(Boolean);

    function findVariant(selections) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return !selections[index] || selections[index] === value;
        });
      });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(0);
      return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function updateVariant(selections) {
      var variant = findVariant(selections);
      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl) {
        var currency = priceEl.getAttribute('data-currency') || '';
        var amountEl = priceEl.querySelector('[data-ruqy-price-amount]');
        if (amountEl) {
          amountEl.textContent = formatMoney(variant.price);
        }
        priceEl.setAttribute('aria-label', currency + ' ' + formatMoney(variant.price));
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        var label = addBtn.getAttribute('data-label-available') || 'Add to Cart';
        var soldOut = addBtn.getAttribute('data-label-sold-out') || 'Sold Out';
        addBtn.querySelector('span').textContent = variant.available ? label : soldOut;
      }

      lengthBtns.forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-ruqy-length');
        var testSelections = selections.slice();
        testSelections[idx] = value;
        var match = findVariant(testSelections);
        btn.disabled = !match || !match.available;
      });
    }

    var currentSelections = variants[0] ? variants[0].options.slice() : [];

    lengthBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var value = btn.getAttribute('data-ruqy-length');
        currentSelections[idx] = value;

        var group = btn.closest('[data-ruqy-length-group]');
        if (group) {
          group.querySelectorAll('[data-ruqy-length]').forEach(function (b) {
            b.classList.remove('selected');
            b.setAttribute('aria-pressed', 'false');
          });
        }

        btn.classList.add('selected');
        btn.setAttribute('aria-pressed', 'true');
        updateVariant(currentSelections);
      });
    });

    updateVariant(currentSelections);
  }

  function initAccordion(root) {
    var items = root.querySelectorAll('[data-ruqy-accordion]');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-ruqy-accordion-trigger]');
      var body = item.querySelector('[data-ruqy-accordion-body]');
      if (!trigger || !body) return;

      if (item.classList.contains('open')) {
        body.style.maxHeight = body.scrollHeight + 'px';
      }

      trigger.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');

        items.forEach(function (i) {
          i.classList.remove('open');
          var t = i.querySelector('[data-ruqy-accordion-trigger]');
          var b = i.querySelector('[data-ruqy-accordion-body]');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (b) b.style.maxHeight = '0';
        });

        if (!wasOpen) {
          item.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ruqy-product]').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ruqy-product]');
    if (section) initProductPage(section);
  });
})();
